export default __webpack_public_path__ + "static/media/ArrowDown.9672a576.svg";